export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as differenceKey,
  initialState as differenceInitialState,
  State as DifferenceState,
} from './reducer';

export {
  getData as differenceGetData,
  getError as differenceGetError,
  getLoading as differenceGetLoading,
  mapData as differenceMapData,
} from './selectors';
